export default {
    "name": "UpdateDashboardReport",
    "kind": "HoudiniMutation",
    "hash": "dcbe56bf2bf76b86c274fe0fd57ed71a932ad74dbd75ea65be24e85ff6150806",

    "raw": `mutation UpdateDashboardReport($input: UpdateDashboardReportInput!) {
  updateDashboardReport(input: $input) {
    dashboardReportId: id
    reportName: name
    reportTitle: title
    json
    shareType
    shareId
    ownerId
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "updateDashboardReport": {
                "type": "DashboardReport",
                "keyRaw": "updateDashboardReport(input: $input)",

                "selection": {
                    "fields": {
                        "dashboardReportId": {
                            "type": "Int",
                            "keyRaw": "dashboardReportId",
                            "visible": true
                        },

                        "reportName": {
                            "type": "String",
                            "keyRaw": "reportName",
                            "visible": true
                        },

                        "reportTitle": {
                            "type": "String",
                            "keyRaw": "reportTitle",
                            "visible": true
                        },

                        "json": {
                            "type": "String",
                            "keyRaw": "json",
                            "visible": true
                        },

                        "shareType": {
                            "type": "DashboardReportShareType",
                            "keyRaw": "shareType",
                            "nullable": true,
                            "visible": true
                        },

                        "shareId": {
                            "type": "Int",
                            "keyRaw": "shareId",
                            "nullable": true,
                            "visible": true
                        },

                        "ownerId": {
                            "type": "Int",
                            "keyRaw": "ownerId",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "UpdateDashboardReportInput"
        },

        "types": {
            "UpdateDashboardReportChartMembership": {
                "chartId": "Int",
                "jsonOverride": "String",
                "rank": "Int"
            },

            "UpdateDashboardReportInput": {
                "charts": "UpdateDashboardReportChartMembership",
                "id": "Int",
                "json": "String",
                "name": "String",
                "shareId": "Int",
                "shareType": "DashboardReportShareType",
                "title": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=a0b7c455246f48f39ef2c16c65d0696263d83243b587c590bc0cb30c9695fe7c";